import React, { useState } from 'react';
import './Forgotpassword.css';
import key from '../../images/key.svg';
import Form from 'react-bootstrap/Form';
import logolight from '../../images/urology-logo-white.svg';
import urologylogotransparent from '../../images/urology-logo-transparent.png';

import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import AuthService from '../services/authservice';
import { useFormik } from 'formik';
import { formikforgetpass, formiksignin } from './validation';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Loader from '../../utils/Loader';


function ForgotpasswordComponent() {
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // code formik : start
    const formik = useFormik({
        ...formikforgetpass,
        onSubmit: async (values) => {
            setLoading(true)
            try {
                const res = await AuthService.forgotPassword(values);

                if (res.status === 'SUCCESS') {
                    setLoading(false)

                    // dispatch(userlogin(userObj)); 
                    toast.success(res.message);
                    // navigate("/admin/dashboard");

                } else {
                    toast.error(res.message);
                    setLoading(false)

                }

            } catch (error) {
                setLoading(false)

                console.error("API Error:", error);
                toast.error("Login Failed!");
            }
        },
    });




    return (
        <>


            <Form onSubmit={formik.handleSubmit}>
                <section className='forgot-blk-main'>
                    <div className='forgot-bg-blk'>
                        <div className='logo-top'>
                            <img src={urologylogotransparent} alt='logo'></img>
                        </div>
                    </div>
                    <div className='forgot-text-blk d-flex align-items-center'>
                        <div className='forgot-content'>
                            <div className='keyicon'>
                                <img src={key} alt='key'></img>
                            </div>
                            <div className='forgot-main-text'>
                                <h2>Forgot Password?</h2>
                                <p>No worries, we'll send you reset instructions.</p>

                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label className='formcontrol-info'>Email Address</Form.Label>
                                    <Form.Control type="email" placeholder="Enter Email Address" className='form-inputs'
                                        name="email"
                                        keyField={"email"}
                                        formik={formik}
                                        value={formik.values.email}
                                        onChange={(e) => formik.setFieldValue("email", e.target.value)}
                                        onBlur={formik.handleBlur}
                                        isInvalid={formik.touched.email && !!formik.errors.email}
                                    />
                                    {formik.touched.email && formik.errors.email ? (
                                        <div className="text-danger">{formik.errors.email}</div>
                                    ) : null}
                                </Form.Group>

                                {/* <Link to="/setnewpass" variant="primary" className='dark-btn reset-btn reset-pw'>Reset password</Link> */}
                                {loading ? (
                                    <Button type="submit" variant="primary" className='dark-btn reset-btn reset-pw' disabled>please Wait...</Button>
                                ) : (
                                    <Button type="submit" variant="primary" className='dark-btn reset-btn reset-pw'>Reset password</Button>
                                )}
                            </div>
                            <Link to="/signin" className='backto-blk'><FaArrowLeftLong />Back to log in</Link>
                        </div>
                    </div>
                </section>
            </Form>

        </>
    );
}

export default ForgotpasswordComponent;